import React from 'react';

export interface CorpusLabelProps {
	corpus: string[];
	lang: string;
	graphViewmode: string;
}

const CorpusLabel: React.FC<CorpusLabelProps> = ({
	corpus,
	lang,
	graphViewmode,
}) => {
	if (graphViewmode === 'trendlinjer') {
		const corpusLabel = corpus[0];
		let languageLabel = '';

		switch (lang) {
			case 'nor':
				languageLabel = 'alle målformer';
				break;
			case 'nno':
				languageLabel = 'nynorsk';
				break;
			case 'nob':
				languageLabel = 'bokmål';
				break;
			case 'smj':
				languageLabel = 'lulesamisk';
				break;
			case 'sma':
				languageLabel = 'sørsamisk';
				break;
			case 'sme':
				languageLabel = 'nordsamisk';
				break;
			case 'fkv':
				languageLabel = 'kvensk';
				break;
			default:
				languageLabel = 'alle språk';
				break;
		}

		return (
			<div className="corpus-label">
				<span>Korpus: </span>
				{`${corpusLabel}, `}
				<span>språk: </span>
				{languageLabel}
			</div>
		);
	} else if (graphViewmode === 'råfrekvens') {
		return <></>;
	} else {
		return (
			<div className="corpus-label">
				<span>Korpus: </span>
				{corpus[0] === 'all' ? 'bok og avis' : corpus[0]}
			</div>
		);
	}
};

export default CorpusLabel;
